
import { Box, Button, Paper } from "@mui/material"
import { useState } from "react";
import { iconos } from "../../../data";



export const BotonesGroup = ({ botonesOpciones }) => {

    const [active, setActive] = useState('');


    return (

        <Paper elevation={4} sx={{width:'100%', maxWidth:'100%', mb:2, px:0, overflow:'hidden', borderRadius:2}}>
            <Box  className='.scroll-thin' sx={{ display:'flex', flexWrap:'nowrap', gap:1, overflowX:'auto',
                overflowY:'hidden', whiteSpace:'nowrap',  '&::-webkit-scrollbar': { height:4, }, px:1, py:1,
                justifyContent:'center',
            }}>
                {botonesOpciones.map((opcion) => {
                    const isActivo = active === opcion.label;
                    const colorActivo = opcion.color || 'primary.main'; 
                    const colorHover = opcion.color || 'primary.dark';

                    return (
                        <Button key={opcion.label} 
                            variant={(isActivo) ? 'contained' : 'outlined'}
                            startIcon={iconos[opcion.icono]}
                            onClick={() => { opcion.onClick?.(); setActive(opcion.label); }} 
                            disabled={ opcion.disabled }
                            sx={{ textTransform:'none', fontSize:13, fontWeight:500, borderRadius:1.5, flexShrink:0, px:1,
                                borderColor:(isActivo) ? colorActivo : '#d1d5db',
                                color:(isActivo) ? 'primary.contrastText' : 'text.primary',
                                backgroundColor:(isActivo) ? colorActivo : 'white',
                                '&.Mui-disabled': {backgroundColor:'#e0e0e0',  color:'#9e9e9e', borderColor:'#e0e0e0'},
                                '&:hover': {backgroundColor: colorHover, borderColor:colorHover, color:'white'},
                        }}>

                            { opcion.label }

                        </Button>
                
                )})}
            </Box>
        </Paper>
    )
}
